import { Text } from "@totalenergiescode/mobility-business-rev-design-system";
import { useTranslation } from "react-i18next";

import { createTidLinkedAccount } from "@/api/graphql/billing/createTidLinkedAccount/api";
import { deleteTidLinkedAccount } from "@/api/graphql/billing/deleteTidLinkedAccount/api";
import { getAccountsLinkableToTid } from "@/api/graphql/billing/getAccountsLinkableToTid/api";
import { getTidLinkedAccounts } from "@/api/graphql/billing/searchTidLinkedAccounts/api";

import { AccountsDetailsTidDelegate } from "./delegate/component";
import { useTidLinkedAccountTypes } from "./hooks";
import { AccountsDetailsTidPayer } from "./payer/component";
import {
  StyledAccountsDetailsTidContainer,
  StyledAccountsDetailsTidHeader,
  StyledLoveHandles,
  StyledTidContainer,
} from "./styles";
import type { AccountsDetailsTidProps } from "./types";

export const AccountsDetailsTid = ({
  accountId,
  getTidLinkedAccountTypesFn,
}: Readonly<AccountsDetailsTidProps>) => {
  const { t: tCompanies } = useTranslation("companies");

  const { data, isLoading } = useTidLinkedAccountTypes({
    getTidLinkedAccountTypesFn,
  });

  return (
    <StyledAccountsDetailsTidContainer>
      <StyledLoveHandles>
        <StyledAccountsDetailsTidHeader>
          <Text variant='title3'>{tCompanies("companies.tid.title")}</Text>
          <Text variant='text2'>{tCompanies("companies.tid.description")}</Text>
        </StyledAccountsDetailsTidHeader>
        <StyledTidContainer>
          <AccountsDetailsTidPayer
            accountId={accountId}
            getTidLinkedAccountsFn={getTidLinkedAccounts}
            createTidLinkedAccountFn={createTidLinkedAccount}
            deleteTidLinkedAccountFn={deleteTidLinkedAccount}
            getAccountsLinkableToTidFn={getAccountsLinkableToTid}
            typeIds={data?.payerTypeIds ?? []}
            customTypeId={data?.customPayerTypeId}
            isLoadingTypes={isLoading}
          />
          <AccountsDetailsTidDelegate
            accountId={accountId}
            getTidLinkedAccountsFn={getTidLinkedAccounts}
            createTidLinkedAccountFn={createTidLinkedAccount}
            deleteTidLinkedAccountFn={deleteTidLinkedAccount}
            getAccountsLinkableToTidFn={getAccountsLinkableToTid}
            typeIds={data?.delegateTypeIds ?? []}
            customTypeId={data?.customDelegateTypeId}
            isLoadingTypes={isLoading}
          />
        </StyledTidContainer>
      </StyledLoveHandles>
    </StyledAccountsDetailsTidContainer>
  );
};
